import { CUSTOM_TASKS_BASE_URL } from "../../../config/service/index";
import { getApiService, WEB_REQUEST_TYPE } from "../../../helpers/apiService";

export const getAllTasksApi = async (params) => {
  try {
    let response = await getApiService(
      WEB_REQUEST_TYPE.GET,
      `${CUSTOM_TASKS_BASE_URL}${params}`
    );
    const { data } = response;
    return data;
  } catch (error) {
    throw Error(error.message);
  }
};

export const getTaskDetailsApi = async (id) => {
  try {
    let response = await getApiService(
      WEB_REQUEST_TYPE.GET,
      `${CUSTOM_TASKS_BASE_URL}${id}`
    );
    const { data } = response;
    return data;
  } catch (error) {
    throw Error(error.message);
  }
};
